import styled from 'styled-components';

export const Container = styled.div`
  width:100%;
  display: flex;
  align-items: flex-start;
  padding-top: 8px;

`;
